var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#604596",
    fillOpacity: 0.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9329 29.5131C38.5133 29.5131 38.1732 29.8533 38.1732 30.2728V39.1733H19.5194V20.5194H34.505C34.9246 20.5194 35.2647 20.1792 35.2647 19.7597C35.2647 19.3402 34.9246 19 34.505 19H18.7597C18.3402 19 18 19.3402 18 19.7597V39.933C18 40.3525 18.3402 40.6927 18.7597 40.6927H38.9329C39.3523 40.6927 39.6926 40.3525 39.6926 39.933V30.2728C39.6926 29.8533 39.3525 29.5131 38.9329 29.5131Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7773 19.4998C41.4806 19.2032 40.9997 19.2032 40.7029 19.4998L28.3292 31.8737L25.2549 28.7994C24.9582 28.5027 24.4772 28.5027 24.1805 28.7994C23.8838 29.0961 23.8838 29.5771 24.1805 29.8738L27.792 33.4853C27.9403 33.6335 28.1348 33.7078 28.3292 33.7078C28.5236 33.7078 28.718 33.6335 28.8664 33.4853L41.7773 20.5742C42.0741 20.2775 42.0741 19.7965 41.7773 19.4998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConduct);
export default __webpack_public_path__ + "static/media/conduct.0874d6c40df78a31a47b2f60d4a862a6.svg";
export { ForwardRef as ReactComponent };